module.exports = __webpack_public_path__ + "static/media/preview.5a5880ca.webp";